// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonLabels = {
  empty: "-",
  none: "无",
  loading: "加载中...",
  total: "总数",
  archived: "已归档",
  hidden: "隐藏",
  emptyText: "(空)",
  avatarAlt: "头像",
  versionTag: "V1",
  nonePaper: "暂无试卷",
  uncategorized: "未分类",
  notSet: "未设置",
  noData: "暂无数据",
  pleaseSelect: "请选择",
  online: "在线",
  offline: "离线",
} as const;
